var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 814.545455a139.636364 139.636364 0 0 1 135.214545 104.727272 46.545455 46.545455 0 0 0 44.916364 34.909091H791.272727a46.545455 46.545455 0 0 0 46.545455-46.545454V116.363636a46.545455 46.545455 0 0 0-46.545455-46.545454h-99.141818a46.545455 46.545455 0 0 0-44.916364 34.909091 139.636364 139.636364 0 0 1-270.42909 0A46.545455 46.545455 0 0 0 331.869091 69.818182H232.727273a46.545455 46.545455 0 0 0-46.545455 46.545454v791.272728a46.545455 46.545455 0 0 0 46.545455 46.545454h99.141818a46.545455 46.545455 0 0 0 44.916364-34.909091A139.636364 139.636364 0 0 1 512 814.545455z m-232.727273-209.454546a23.272727 23.272727 0 0 1 0-46.545454h93.090909a23.272727 23.272727 0 0 1 0 46.545454z m186.181818 0a23.272727 23.272727 0 0 1 0-46.545454h93.09091a23.272727 23.272727 0 0 1 0 46.545454z m186.181819 0a23.272727 23.272727 0 0 1 0-46.545454h93.090909a23.272727 23.272727 0 0 1 0 46.545454z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTicket);
export default __webpack_public_path__ + "static/media/support-ticket.9ea2dc62ce378f2b9f3e250c298432a7.svg";
export { ForwardRef as ReactComponent };